import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-fab-button",
  templateUrl: "./fab-button.component.html",
})
export class FabButtonComponent {

  @Input() title: string = "";
  @Input() iconClass: string = "";
  @Input() backgroundClass: string = "bg-blueGray-700";

  @Output() event = new EventEmitter();
  click() {
    this.event.emit('');
  }
}
